export type UserRole = 'admin' | 'operator';

export function getUserRole(): UserRole {
  return localStorage.getItem('user_role') === 'operator' ? 'operator' : 'admin';
}

export function isOperatorUser(): boolean {
  return getUserRole() === 'operator';
}
